// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumb_wrapper__NFVSE","wrapper__item":"Breadcrumb_wrapper__item__V2S41","label":"Breadcrumb_label__pPY4q","separator":"Breadcrumb_separator__azDMV"};